import {
    FETCH_CONTACT_SUPPORT_MESSAGES_REQUEST,
    FETCH_CONTACT_SUPPORT_MESSAGES_SUCCESS,
    FETCH_CONTACT_SUPPORT_MESSAGES_FAILURE,
    UPDATE_CONTACT_SUPPORT_MESSAGE_REQUEST,
    UPDATE_CONTACT_SUPPORT_MESSAGE_SUCCESS,
    UPDATE_CONTACT_SUPPORT_MESSAGE_FAILURE,
  } from '../actions/types';
  
  const initialState = {
    messages: [],
    loading: false,
    error: null,
    message: '',
  };
  
  export default function contactSupportReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_CONTACT_SUPPORT_MESSAGES_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_CONTACT_SUPPORT_MESSAGES_SUCCESS:
        return {
          ...state,
          loading: false,
          messages: action.payload,
          message: 'Contact support messages loaded successfully',
        };
  
      case FETCH_CONTACT_SUPPORT_MESSAGES_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          messages: [],
        };
  
      case UPDATE_CONTACT_SUPPORT_MESSAGE_REQUEST:
        return { ...state, loading: true, error: null };
  
      case UPDATE_CONTACT_SUPPORT_MESSAGE_SUCCESS:
        return {
          ...state,
          loading: false,
          messages: Array.isArray(state.messages)
            ? state.messages.map((msg) =>
                msg.message_id === action.payload.message_id ? action.payload : msg
              )
            : state.messages,
          message: 'Contact support message updated successfully',
        };
  
      case UPDATE_CONTACT_SUPPORT_MESSAGE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  }
  